export default __webpack_public_path__ + "static/media/ic_access_time_white_24px.44beeda5.svg";